// A person's age in whole, completed years from an age given in days. Uses
// 365.25 (to average in leap years) and floors to completed years. The
// microbiome-age backend buckets ages the same way when selecting evaluation
// ranges, so these must stay in agreement — keep this the single source.
// Note: this differs from the 365-day display helpers (e.g. stringifyDaysOld);
// don't conflate them.
export function getAgeInYears(ageInDays) {
    return Math.floor(ageInDays / 365.25);
}
//# sourceMappingURL=getAgeInYears.js.map